<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w4cPML/tc-custom/9781576336441.jpg?1717009939044" alt="This image is the cover for the book GED Test Prep Commonly Confused Words Review--Exambusters Flash Cards--Workbook 11 of 13, Exambusters GED"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">GED Test Prep Commonly Confused Words Review--Exambusters Flash Cards--Workbook 11 of 13, Exambusters GED
      </h1>
      <p class="bookDescription body article font2">
        <p>"GED Prep Flashcard Workbook 11: WORDS COMMONLY CONFUSED" Do you know the difference between "fewer" and "less," when to use "it's" or "its," or how to distinguish between "historical" and "historic" or "tortuous" and "torturous?" 500 pairs of commonly confused words, some so frequently misused that their wrong application has become acceptable to many ears. Includes part of speech, pronunciation, simple definition, and usage example. [==================] ADDITIONAL WORKBOOKS: "GED Prep Flashcard Workbook 9: COLLEGE PREP VOCABULARY-Intermediate: Level 2" 350 frequently tested vocabulary words every college freshman should know. Includes sample sentence, part of speech, pronunciation, succinct, easy-to-remember definition, and common synonyms and antonyms. _______________ "GED Prep Flashcard Workbook 12: UNITED STATES HISTORY" 600 questions. Topics: Colonial Era, Revolutionary Era, Age of Expansion, Civil War, Reconstruction, The 1920s, The Depression, and more. ==================================== "EXAMBUSTERS GED Prep Workbooks" provide comprehensive, fundamental GED review--one fact at a time--to prepare students to take practice GED tests. Each GED study guide focuses on one specific subject area covered on the GED exam. From 300 to 600 questions and answers, each volume in the GED series is a quick and easy, focused read. Reviewing GED flash cards is the first step toward more confident GED preparation and ultimately, higher GED exam scores!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        GED Exambusters
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Cram Now!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a84fae5